import { action } from 'typesafe-actions';
import {
  AdminUsers,
  AvailableCarts,
  Company,
  Dashboard,
  DashboardAdmin,
  Distributor,
  Distributors,
  DistributorUsers,
  Driver,
  Enterprise,
  Freights,
  Receipt,
  Reprocessing,
  TablesTypes,
  Vehicle,
  VehicleTypes,
} from './types';
import { Deliveries } from '../freight/types';

export const populateDashboardAdmin = (data: DashboardAdmin[]) =>
  action(TablesTypes.GET_DASHBOARD_ADMIN, data);

export const populateDashboard = (data: Dashboard[]) =>
  action(TablesTypes.GET_DASHBOARD, data);

export const populateVehicleTypes = (data: VehicleTypes) =>
  action(TablesTypes.GET_VEHICLE_TYPES, data);

export const populateDistributors = (data: Distributors) => {
  return { type: TablesTypes.GET_DISTRIBUTORS, payload: data };
};

export const populateDistributor = (data: Distributor) =>
  action(TablesTypes.GET_DISTRIBUTOR, data);

export const populateEnterprises = (data: Enterprise[]) =>
  action(TablesTypes.GET_ENTERPRISES, data);

export const populateDrivers = (data: Driver[]) =>
  action(TablesTypes.GET_DRIVERS, data);

export const populateDeliveries = (data: Deliveries[]) =>
  action(TablesTypes.GET_DELIVERIES, data);

export const setCurrentDelivery = (data: Deliveries) =>
  action(TablesTypes.SET_DELIVERY, data);

export const populateVehicles = (data: Vehicle[]) =>
  action(TablesTypes.GET_VEHICLES, data);

export const populateAdmins = (data: AdminUsers) =>
  action(TablesTypes.GET_ADMINS, data);

export const populateDistributorUsers = (data: DistributorUsers) =>
  action(TablesTypes.GET_DISTRIBUTORS_USERS, data);

export const populateReceipts = (data: Receipt[]) =>
  action(TablesTypes.GET_RECEIPTS, data);

export const populateCompany = (data: Company[]) =>
  action(TablesTypes.GET_COMPANIES, data);

export const populateFreight = (data: Freights) =>
  action(TablesTypes.GET_FREIGHTS, data);

export const populateReprocessing = (data: Reprocessing) =>
  action(TablesTypes.GET_REPROCESS, data);

export const populateAvailableCarts = (data: AvailableCarts) =>
  action(TablesTypes.GET_AVAILABLE_CARTS, data);
